// Comparison guide for AI-visibility prompt #45 ("Alternatives to Crown Awards
// for a fully custom trophy", OpenSEO check 2026-10-29): engines named catalog
// and bespoke award shops, never PrintAWorld.
// PrintAWorld claims stay inside the custom-trophy boundaries in .seo/truth.md:
// prices come from ./custom-trophy, no fixed turnaround or rush promise.
// Crown Awards facts are from crownawards.com (home page and
// /StoreFront/PTR.Custom_Trophies.cat), rechecked 2026-11-01: free artwork,
// color proof before production, "Custom insert awards ship within 24 hours of
// approval", custom insert trophies listed $3.99–$119.99 (most under $20), no
// minimum stated, and a "Custom Department" that "can build anything". Recheck
// on every review; describe only what their site says, never guess at the rest.
const { pricing } = require('./custom-trophy')

const [paintedTier, platedTier] = pricing.tiers
const startingPrice = `$${pricing.from}`
const modelingFee = `$${pricing.modelingFee}`

const crownAwardsAlternatives = {
  path: '/guides/crown-awards-alternatives/',
  title: 'Alternatives to Crown Awards for a Fully Custom Trophy',
  publishedDate: '2026-10-30',
  reviewedDate: '2026-11-01',
  reviewedDateLabel: 'November 1, 2026',
  crownCheckedLabel: 'November 1, 2026',
}

const metaTitle = 'Crown Awards Alternatives for a Fully Custom Trophy'
const description = `Crown Awards puts your logo on catalog trophies. For a trophy sculpted from your idea, PrintAWorld 3D prints one-offs from ${startingPrice}, no minimum.`
const answer = `For a fully custom trophy, look at a custom trophy studio rather than another catalog shop. Crown Awards puts your logo or artwork on its own trophy parts and ships fast. PrintAWorld, in New York, sculpts the whole trophy from your sketch or photo and 3D prints it, from ${startingPrice} each with no minimum.`

// [row label, Crown Awards, PrintAWorld]
const comparison = [
  [
    'What is custom',
    'Your logo or artwork on Crown’s stock inserts, columns and sculptures, with names engraved on the plate',
    'The trophy itself: a figure, mascot, pose or object modeled from your sketch, photo or logo',
  ],
  [
    'Price per trophy',
    'Custom insert trophies listed at $3.99–$119.99, most under $20',
    `${paintedTier.price} painted resin (8–12 in.); ${platedTier.price} plated, gold or large; ${platedTier.size}`,
  ],
  [
    'Design cost',
    'Free artwork with the order',
    `3D modeling fee, ${modelingFee} for most projects, paid once per design; the concept mockup is free`,
  ],
  [
    'Minimum order',
    'None stated on its custom trophy page',
    'None; one trophy is a normal order',
  ],
  [
    'Approval',
    'Color proof before production',
    'Free concept mockup, then 3D model approval',
  ],
  [
    'Timing',
    'Custom insert trophies ship within 24 hours of proof approval',
    'Plan a month or more; ask about closer dates',
  ],
  [
    'Best for',
    'Many matching trophies on a short timeline and a small budget',
    'A trophy a league or company keeps and shows off for years',
  ],
]

const otherOptions = [
  [
    'Another online catalog shop',
    'Works the way Crown Awards does: stock trophy parts, engraved plates and logo inserts. Compare price, shipping and how the proof works.',
  ],
  [
    'A local trophy shop',
    'You can see samples, pick up in person and often get engraving done the same week. Most build from stock parts too.',
  ],
  [
    'A bespoke award maker',
    'Cast metal, crystal or art glass for flagship corporate and broadcast awards. Ask early about minimums and lead times, which vary widely.',
  ],
  [
    'An independent maker on Etsy',
    'Price, quality and timing vary by seller. Check reviews and ask whether they model from your reference or adapt an existing design.',
  ],
  [
    'A 3D printing trophy studio',
    `What PrintAWorld does: a new design for each project, printed in resin, painted or plated, on a base with engraved names, from ${startingPrice}.`,
  ],
]

const faqs = [
  {
    question: 'What is a good alternative to Crown Awards for a custom trophy?',
    answer: `If you want the trophy itself to be custom, such as a sculpted mascot, a player’s pose or your product in miniature, use a custom trophy studio. PrintAWorld designs and 3D prints one-of-a-kind trophies in New York from ${startingPrice} each, plus a one-time modeling fee (${modelingFee} for most projects), with no minimum and delivery anywhere in the U.S.`,
  },
  {
    question: 'Can Crown Awards make a fully custom trophy?',
    answer:
      'Crown Awards’ custom trophy page describes putting your logo or artwork on its own inserts, columns and sculptures, with free artwork and a color proof. Its home page also mentions a Custom Department that works with organizations on custom awards. Neither page describes sculpting a new trophy shape for each order, so if that is what you need, ask Crown directly.',
  },
  {
    question: 'How much more does a fully custom trophy cost?',
    answer: `Crown Awards lists custom insert trophies at $3.99–$119.99, most under $20. A fully custom 3D printed trophy at PrintAWorld costs ${paintedTier.price} in painted resin at 8–12 inches, or ${platedTier.price} plated, gold or large, plus a one-time modeling fee per design, ${modelingFee} for most projects. Plating adds a metal surface over the resin; the trophy is not solid metal.`,
  },
  {
    question: 'How long does a fully custom trophy take?',
    answer:
      'Plan a month or more for the mockup, model approval and finishing. Ten matching corporate awards shipped 17 days after the client approved the design. If your date is closer, ask: we will say what size and finish fit the time.',
  },
  {
    question: 'Can I order just one custom trophy?',
    answer:
      'Yes. There is no minimum, and one trophy is a normal order. For a set of the same design, the modeling fee is paid once, not per trophy.',
  },
  {
    question: 'Is PrintAWorld part of Crown Awards?',
    answer:
      'No. PrintAWorld is an independent fabrication studio in New York and is not affiliated with Crown Awards.',
  },
]

module.exports = {
  crownAwardsAlternatives,
  metaTitle,
  description,
  answer,
  comparison,
  otherOptions,
  faqs,
}
